import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { PendenciasFinanceirasRow } from 'src/modules/serasa/serasa.pj.types'

export type PendenciasFinanceirasProps = {
    pendenciasFinanceiras: PendenciasFinanceirasRow
}

export default function PendenciasFinanceiras({ pendenciasFinanceiras }: PendenciasFinanceirasProps) {
    return (
        <>
            <Divider textAlign="center">Pendências Financeiras</Divider>
            {pendenciasFinanceiras && (
                <>
                    <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                        <GridItem
                            label="Quantidade de Pendências"
                            value={pendenciasFinanceiras.qtde_pendencias.toFixed(0)}
                            xs={6}
                        />
                        <GridItem
                            label="Total Ocorrências"
                            value={pendenciasFinanceiras.ocorrencias
                                .reduce((acc, occ) => acc + occ.total_ocorrencias, 0)
                                .toFixed(0)}
                            xs={6}
                        />
                        <GridItem
                            label="Total Valores"
                            value={pendenciasFinanceiras.ocorrencias
                                .reduce((acc, occ) => acc + occ.total_valores, 0)
                                .toFixed(2)}
                            xs={6}
                        />
                    </Grid>

                    {pendenciasFinanceiras.ocorrencias?.map((ocorrencia, index) => (
                        <div key={index}>
                            <Divider textAlign="center">Ocorrência {index + 1}</Divider>

                            <Grid
                                container
                                spacing={1}
                                paddingTop={2}
                                paddingBottom={2}
                                paddingLeft={5}
                                paddingRight={5}
                            >
                                <GridItem label="Fonte" value={ocorrencia.fonte} xs={6} />
                                <GridItem
                                    label="Total Ocorrências"
                                    value={ocorrencia.total_ocorrencias.toFixed(0)}
                                    xs={6}
                                />
                                <GridItem label="Total Valores" value={ocorrencia.total_valores.toFixed(2)} xs={6} />
                            </Grid>

                            {ocorrencia.detalhes?.map((detalhe, detalheIndex) => (
                                <Grid key={detalheIndex} container spacing={1}>
                                    <GridItem label="Data" value={formatDate(detalhe.data, 'dd/MM/yyyy')} xs={6} />
                                    <GridItem label="Modalidade" value={detalhe.modalidade} xs={6} />
                                    <GridItem label="Aval" value={detalhe.aval} xs={6} />
                                    <GridItem label="Valor" value={detalhe.valor.toFixed(2)} xs={6} />
                                    <GridItem label="Contrato" value={detalhe.contrato} xs={6} />
                                    <GridItem label="Origem" value={detalhe.origem} xs={6} />
                                </Grid>
                            ))}
                        </div>
                    ))}
                </>
            )}
        </>
    )
}
